import React, { useState, useEffect, useContext } from "react";

//import css
import "./RecentPaymentsCards.scss";

//import icons
import { FaPercentage } from "react-icons/fa";
import { MdCreditScore } from "react-icons/md";

//imports for user data
import { useSelector, useDispatch } from "react-redux";

//functions for datat fetching
import { fetchTenantPayments } from "../../../../redux/slices/sliceActions";

//import context
import { MyContext } from "../../../../tenantsDashContext";

const RecentPaymentsCards = ({ awaitingApproval }) => {
  //check shared value from context
  const { sharedValue, setSharedValue } = useContext(MyContext);

  //data fetched from the store
  const dispatch = useDispatch();
  const { user, profile } = useSelector((state) => state.landlordslice);
  const token = user?.data?.accessToken;
  const id = user?.data?.user?.user_id;
  const house_id = user?.data?.house?.house_id;

  const [paymentsReceived, setPaymentsReceived] = useState([]);

  useEffect(() => {
    console.log(user?.data?.house?.house_id);

    dispatch(fetchTenantPayments({ house_id, token })).then((res) => {
      if (awaitingApproval) {
        console.log("awaiting approval", res.payload?.data);
        setPaymentsReceived(
          res.payload?.data.filter((payment) => !payment?.isVerified),
        );
        return;
      }
      // Filter payments to only include those from the current month and year
      const currentMonth = new Date().getMonth();
      const currentYear = new Date().getFullYear();
      const filteredPayments = res.payload?.data.filter((payment) => {
        const paymentDate = new Date(payment.createdAt || payment.payment_date);
        return (
          paymentDate.getMonth() === currentMonth &&
          paymentDate.getFullYear() === currentYear
        );
      });
      setPaymentsReceived(filteredPayments);
    });
  }, [user]);

  const paymentData = {
    payments: paymentsReceived,
  };
  console.log("Payment data", paymentData);

  const [visiblePayments, setVisiblePayments] = useState(5);
  const [expandedCardIndex, setExpandedCardIndex] = useState(null);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const getPaymentStatus = (status) => {
    return status === "partialy_paid" ? "Partial" : "Complete";
  };

  const handleSeeMore = () => {
    setVisiblePayments((prevVisiblePayments) => prevVisiblePayments + 5);
  };

  const handleHideAll = () => {
    setVisiblePayments(5);
  };

  const toggleExpandCard = (index) => {
    setExpandedCardIndex(expandedCardIndex === index ? null : index);
  };

  return (
    <div className="payments-container">
      {paymentData?.payments?.length < 1 && <>No Payments yet for this month</>}
      {paymentData.payments.slice(0, visiblePayments).map((payment, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <div className="card" onClick={() => toggleExpandCard(index)}>
            <div className="icon">
              {getPaymentStatus(payment?.invoice.payment_status) ===
              "Partial" ? (
                <FaPercentage />
              ) : (
                <MdCreditScore />
              )}
            </div>
            <div className="description-and-ammount">
              <div className="description">
                {shortenString(payment?.narration) || "No description"}
              </div>
              <div className="amount">{payment?.amount}</div>
            </div>
            <div className="date">{formatDate(payment?.payment_date)}</div>
          </div>

          {expandedCardIndex === index && (
            <div className="extra-info">
              <div className="extra-info-title">Transaction Details</div>
              <div className="details-and-title">
                <div className="tile">Invoice ID:</div>
                <div className="details">
                  {" "}
                  PAY{payment?.invoice.slice(0, 3)}
                </div>
              </div>
              <div className="details-and-title">
                <div className="tile">Rent Amount:</div>
                <div className="details"> {payment?.rent || 0}</div>
              </div>
              <div className="details-and-title">
                <div className="tile"> Arrears Amount:</div>
                <div className="details"> {payment?.arrears || 0}</div>
              </div>
              <div className="details-and-title">
                <div className="tile">Garbage Charge: </div>
                <div className="details">{payment?.garbage || 0}</div>
              </div>
              <div className="details-and-title">
                <div className="tile">Water Bill Amount:</div>
                <div className="details"> {payment?.water || 0}</div>
              </div>
              <div className="details-and-title">
                <div className="tile">Service Fee Amount:</div>
                <div className="details"> {payment?.service_charge || 0}</div>
              </div>
            </div>
          )}
        </div>
      ))}

      {visiblePayments < paymentData.payments.length && (
        <div className="see-more-buttons-container">
          <button className="see-more-button" onClick={handleSeeMore}>
            See More
          </button>
        </div>
      )}

      {visiblePayments > 5 && (
        <div className="see-more-buttons-container">
          <button className="hide-all-button" onClick={handleHideAll}>
            Hide All
          </button>
        </div>
      )}
    </div>
  );
};

function shortenString(str) {
  if (str?.length > 14) {
    return str.slice(0, 14) + "...";
  }
  return str;
}

export default RecentPaymentsCards;
